import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'
import LazyYouTubeEmbed from '@/commons/LazyYouTubeEmbed'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-04-05'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Fitness Classes Singapore | Book Online Now!</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Looking for fitness classes in Singapore? Forget the boredom of stereotype exercises and join these instructor led, fun wrapped exercise classes."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/fitness-classes-in-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="Fitness Classes Singapore | Book Online Now!"/>
        <meta property="og:description" content="Looking for fitness classes in Singapore? Forget the boredom of stereotype exercises and join these instructor led, fun wrapped exercise classes." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-09T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/group-fitness-class.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/group-fitness-class.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/fitness-classes-in-singapore"/>
        <meta name="twitter:title" content="Fitness Classes Singapore | Book Online Now!"/> 
        <meta name="twitter:description" content="Looking for fitness classes in Singapore? Forget the boredom of stereotype exercises and join these instructor led, fun wrapped exercise classes."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/fitness-classes-in-singapore" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#breadcrumblist","itemListElement":[{"@type":"ListItem","@id":"https://www.stringssg.com/#listItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"},"nextItem":"https://www.stringssg.com/blogs/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/blogs/#listItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/","name":"blogs","url":"https://www.stringssg.com/blogs/"},"previousItem":"https://www.stringssg.com/#listItem","nextItem":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#listItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/","name":"fitness-class","description":"Looking for fitness classes in Singapore? Forget the boredom of stereotype exercises and join these instructor led, fun wrapped exercise classes.","url":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/"},"previousItem":"https://www.stringssg.com/blogs/#listItem"}]},{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG Singapore","url":"https://www.stringssg.com/"},{"@type":"WebSite","@id":"https://www.stringssg.com/#website","url":"https://www.stringssg.com/","name":"StringsSG Singapore","inLanguage":"en-US","publisher":{"@id":"https://www.stringssg.com/#organization"}},{"@type":"VideoObject","@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#video","name":"Fitness Classes Singapore | Book Online Now!","description":"Watch this 30 mins video to try a bodyweight workout!","thumbnailUrl":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/group-fitness-class.jpg"],"uploadDate":"2014-05-03T08:00:00+08:00","duration":"PT34M04S","contentUrl":"https://youtu.be/k_0MgIJdF6k","embedUrl":"https://www.youtube.com/embed/k_0MgIJdF6k","interactionStatistic":{"@type":"InteractionCounter","interactionType":{"@type":"WatchAction"},"userInteractionCount":5647018}},{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#webpage","url":"https://www.stringssg.com/blogs/fitness-classes-in-singapore","name":"Fitness Classes Singapore | Book Online Now!","description":"Looking for fitness classes in Singapore? Forget the boredom of stereotype exercises and join these instructor led, fun wrapped exercise classes.","inLanguage":"en-US","isPartOf":{"@id":"https://www.stringssg.com/#website"},"breadcrumb":{"@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#breadcrumblist"},"video":{"@id":"https://www.stringssg.com/blogs/fitness-classes-in-singapore/#video"},"datePublished":"2025-01-09T07:30:46+00:00","dateModified":"2022-11-10T21:22:19+08:00"}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-xl md:text-2xl font-semibold text-center'><span className='uppercase'>Fitness Classes in Singapore</span><br/><span>- Stay fit with fun filled classes!</span></h1>
                <div className='text-gray-400 text-xs text-center'>
                    <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2 space-y-2'>
                    <h3 className='font-bold'>What is a group Fitness class?</h3>
                    <p>
                        Group fitness classes are workouts that are instructor led for a group of people like 
                        <Link href="/blogs/zumba-classes-in-singapore" className='text-orange-600'> Zumba</Link>
                        , Bodyweight workouts, HIIT classes and may more.
                    </p>
                    <p>
                        Small group workouts have always existed, but it is only in the recent years that it has become strikingly popular. These fun wrapped exercise classes 
                        are a great way to benefit our body, mind and soul.
                    </p>
                    <div className='relative h-96 max-full my-5'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/health+and+fitness/group-fitness-class.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='BodyCombat Singapore'
                        />          
                    </div>
                </div>
                <div className='pt-5 space-y-2'>
                    <h2 className='text-xl md:text-2xl text-center font-bold'>
                        Best Instructors for Fitness Classes in Singapore
                    </h2>
                </div>
                <div className='space-y-2 py-5'>
                    <h3 className='font-bold pt-5 text-lg'>
                        1. JG Fit Singapore
                    </h3>
                    <p>                     
                        With JG Fit, we help you to begin your journey to greatness​​! It STARTS with YOU!
                    </p>   
                    <div className='relative h-96 max-w-xl'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/jg-fit.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}} 
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='JG Fit Singapore - StringsSG'
                        />          
                    </div>
                    <p> 
                        JG Fit SG offers personal training programme via an invite-only gym, at your home through remote coaching programme. In addition to personal training, 
                        JG Fit also offers corporate wellness programmes and group fitness classes for people to enjoy and workout a good sweat. With client centric coaches, 
                        JG Fit helps you to begin your journey to greatness! From weight loss, to nutrition, we cover it all. JG Fit SG wants to be Singapore&apos;s premier fitness service 
                        provider, consistently delivering client&apos;s results with high-quality services. 
                    </p>         
                    <p>
                        Contact Profile - 
                        <Link href="/profile/jg-fit-singapore-9499" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/jg-fit-singapore-9499</Link>
                    </p>
                    <p>
                        WebSite - 
                            <a href="https://www.jgfitsg.com/" target="_blank" rel="noreferrer nofollow noopener" className='text-orange-600'> https://www.jgfitsg.com/</a>
                    </p>
                    <h3 className='font-bold pt-5 text-lg'>
                        2. Maria Rosete - Advantage Pilates Singapore
                    </h3>
                    <div className='relative h-96 max-w-xl'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/advantage-pilates.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}     
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Maria Rosete - Advantage Pilates Singapore - StringsSG'
                        />          
                    </div>
                    <p> 
                        Choose the workout/ budget/ timeslot and instructor suitable for your preference and lifestyle, and according to your fitness level...
                    </p> 
                    <p> 
                        Our affordable live-streaming online classes are results-oriented. Your Instructor can personally motivate, challenge, progress, and 
                        correct your form live online. Both Private and group classes are available. Now, you can work out at your convenience, anytime, and anywhere and know that you will still have the same care, guidance and support from your favourite Instructor.    
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/maria-rosete-4315" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/maria-rosete-4315</Link>
                    </p>
                    <p>
                        WebSite - 
                        <a href="https://www.advantagepilates.sg/" target="_blank" rel="noreferrer nofollow noopener" className='text-orange-600'> https://www.advantagepilates.sg/</a>
                    </p> 
                    <h3 className='font-bold pt-5 text-lg'>
                        3. Gina Tan
                    </h3>
                    <div className='relative h-96 max-w-xl'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/female-trainer/gina-tan.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}  
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Gina Tan - StringsSG'
                        />          
                    </div>
                    <p> 
                        <br/>
                        I have been teaching in the fitness industry for 6 years now, specializing in yoga and strength training. Competent in teaching both individuals as well as group classes for events/corporates/outdoors. I started working out with the initial goal to lose weight but then I got hooked onto fitness and gradually built my career in it.
                        <br/>                        
                        Certifications:
                        <br/> - Bachelor in Sports &amp; Exercise Science
                        <br/> - ACE Personal Trainer
                        <br/> - ACE Group Fitness Instructor
                        <br/> - 400hr Hatha Vinyasa Yoga Teacher training
                        <br/> - SFA + AED 
                        <br/>                        
                        Do contact me to inquire more for any of my services -
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/gina-tan-1916" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/gina-tan-1916</Link>
                        <br/>
                        Instagram - <a className='text-orange-600' href='https://www.instagram.com/kimizafit/?hl=en' rel='noreferrer nofollow' target="_blank">@kimizafit</a>
                    </p> 
                    <h3 className='font-bold pt-5 text-lg'>
                        4. Lishan Lim
                    </h3>
                    <div className='relative h-96 max-w-md flex'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/lishan-lim.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Ray cheng - StringsSG'
                        />          
                    </div>
                    <p>
                        I am a yoga teacher and have been practising for over 5 years and have been teaching group classes, corporate, private, workshops, events and retreats, from kids to 
                        elderly in Hatha, Vinyasa, Yin styles and meditation.
                    </p>  
                    <p>
                        I am also a HIIT instructor and can teach strength and conditioning classes, in addition to a whole host of holistic healing methods from reiki to sound healing and more.
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/lishan-lim-2173" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/lishan-lim-2173</Link>
                    </p>  
                    <h3 className='font-bold pt-5 text-lg'>
                        5. Ray Cheng
                    </h3>
                    <div className='relative h-96 max-w-md flex'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/ray-cheng.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='Ray cheng - StringsSG'
                        />          
                    </div>
                    <p>
                        Hi everyone, Ray here. I am a group instructor teaching kickboxing, hiit, fat burn extreme, game fit and other senior fitness programmes. 
                        I have been practicing muay thai for more than a decade now and have been training in Thailand as well.  
                        I like to make my classes enjoyable for my participants, catering to all fitness levels by blending different workouts together for the maximum results and fun. 
                        Find out more today!
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/ray-cheng-3259" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/ray-cheng-3259</Link>
                    </p>  
                    <h3 className='font-bold pt-5 text-lg'>
                        6. D Lim
                    </h3>
                    <div className='relative h-96 max-w-md flex'>
                        <Image className=''
                            src={s3Static + "blog/health+and+fitness/d-lim.webp"}
                            fill
                            style={{objectFit: 'contain', objectPosition: 'left'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='D Lim - StringsSG'
                        />          
                    </div>
                    <p>
                        I am ACE Certified, i have been giving bootcamp trainings for 1 year and am currently giving group fitness classes forward to coach people for weight loss and to shape up!
                    </p>                    
                    <p>
                        Contact Profile - 
                        <Link href="/profile/d-lim-2286" prefetch={false} className='text-orange-600'> https://www.stringssg.com/profile/d-lim-2286</Link>
                    </p>                    
                </div>               
                <div className='px-2 pt-10 space-y-2 text-center'>
                    <h2 className='text-xl uppercase font-bold'>
                        Benefits of Group Fitness Class
                    </h2>
                </div>
                <ul className='py-2 space-y-2 px-6'>
                    <li className='list-disc'>
                        Many a times, it gets difficult to motivate ourselves to hit the gym. Group training helps in such situations by giving us that extra push or 
                        encouragement to work out with friends or acquaintances.
                    </li>       
                    <li className='list-disc'>
                        Group training has a more structured modus operandi and thus makes us more accountable to ourselves.
                    </li> 
                    <li className='list-disc'>
                        Since an individual works out in a group, a healthy competition develops, which in turn motivates and helps to reach one&apos;s fitness goals at a faster rate.
                    </li>        
                    <li className='list-disc'>
                        Working out in groups are fun and hence one enjoys the workout more.
                    </li> 
                    <li className='list-disc'>
                        Since the group training programs are run by fitness professionals who bring in lot of variety to the sessions, it helps to break the boredom or stereotype workout routines.
                    </li>   
                    <li className='list-disc'>
                        The fitness instructors can give more personal attention to the members.
                    </li>       
                </ul>
                <div className='py-10 text-center'>
                    <Link href="/sg/personal-trainer" className='px-3 py-3 border border-amber-600 text-orange-600 rounded-lg'>
                            Get a Fitness Class Instructor
                    </Link>
                    <h3 className='text-center font-bold text-lg text-gray-500 pt-10 px-2'>Watch this 30 mins video to try a bodyweight workout!</h3>
                    <LazyYouTubeEmbed videoId="k_0MgIJdF6k" title="Watch this 30 mins video to try a bodyweight workout!" /> 
                </div>
            </div>
            <h2 className='text-center text-xl uppercase'>You may also like</h2>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>
            <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                Get a Fitness Class Instructor
            </Link>
        </div>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '128634041116395');
            fbq('track', 'PageView');`}
        </Script>
    </>
  )
}